<div class="float-end">
  <a href="{{href}}"
     class="card-header-action"
     rel="noreferrer noopener"
     target="_blank"
  >
    <small class="text-medium-emphasis">{{text ?? 'docs'}}</small>
  </a>
</div>
